import angular from 'angular';
import fbListFilterCtrl from './fb-list-filter.controller'

let fbListFilter = {
  template: require('./fb-list-filter.html'),
  bindings: {
    list: '<',
    height: '<'
  },
  controller: fbListFilterCtrl,
  require: {
    filterListCtrl: '^lfFilterList'
  },

}

export default angular.module('components.fbListFilter', [])
  .component('fbListFilter', fbListFilter)
  .name;



// WEBPACK FOOTER //
// ./project/components/fb-list-filter/index.js